import { Action } from '../action';
import { AuthType } from '../Auth/action';
import { PdfState } from './state';
import { PdfType } from './action';

export const initialState: PdfState = {
    buttonEnabled: false,
    printRequested: false,
    filterValues: [],
    filterValuesSelected: [],
};

const filterSelected = (previouslySelected: string[], selection: string): string[] => {
    if (previouslySelected.includes(selection)) {
        return previouslySelected.filter(prev => prev !== selection);
    }

    return [...previouslySelected, selection];
}

export const pdfReducer = (state: PdfState | undefined, action: Action): PdfState => {
    state = state ?? initialState;

    switch (action.type) {
        case PdfType.PdfRequested:
            return { ...state, printRequested: true };
        case PdfType.PdfFinished:
            return { ...state, printRequested: false, filterValuesSelected: [] };
        case PdfType.DisablePdfButton:
            return { ...state, buttonEnabled: false };
        case PdfType.EnablePdfButton:
            return { ...state, buttonEnabled: true };
        case PdfType.FilterValuesChanged:
            return { ...state, filterValues: action.filterValues };
        case PdfType.FilterValueSelected:
            return { ...state, filterValuesSelected: filterSelected(state.filterValuesSelected, action.selection) };
        case AuthType.TokenExpired:
            return initialState;
        default:
            return state;
    }
};
